var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmountToilets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.3,
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.125 11.002h3.75c.69 0 1.25-.537 1.25-1.2v-7.2c0-.662-.56-1.2-1.25-1.2h-2.5c-.69 0-1.25.538-1.25 1.2v8.4zM2.125 8.602c-.69 0-1.25.538-1.25 1.2 0 .663.56 1.2 1.25 1.2h10v-2.4h-10zM14.167 13.28c1.019-.328 1.706-1.244 1.706-2.276H2.125c0 2.48 1.448 4.752 3.75 5.88l-.625 2.52h8.125v-4.976a1.192 1.192 0 01.792-1.148z"
  }))));
}
export default SvgAmountToilets;